
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("6ooPx"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("6ooPx", function(module, exports) {

let $4a783ebd071e1efd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a783ebd071e1efd$var$load("fSobj"),
    $4a783ebd071e1efd$var$load("74u2y"),
    $4a783ebd071e1efd$var$load("2YffH"),
    $4a783ebd071e1efd$var$load("iDB1L"),
    $4a783ebd071e1efd$var$load("1aTst"),
    $4a783ebd071e1efd$var$load("eEyVs"),
    $4a783ebd071e1efd$var$load("6mHrv"),
    $4a783ebd071e1efd$var$load("awWN9"),
    $4a783ebd071e1efd$var$load("agAjs"),
    $4a783ebd071e1efd$var$load("9CYct"),
    $4a783ebd071e1efd$var$load("iIoyG"),
    $4a783ebd071e1efd$var$load("2xn4F"),
    $4a783ebd071e1efd$var$load("hZtKG"),
    $4a783ebd071e1efd$var$load("iNmaF"),
    $4a783ebd071e1efd$var$load("lVO3w"),
    $4a783ebd071e1efd$var$load("hyzoX"),
    $4a783ebd071e1efd$var$load("h9Ed7"),
    $4a783ebd071e1efd$var$load("eBRUf"),
    $4a783ebd071e1efd$var$load("bogQM"),
    $4a783ebd071e1efd$var$load("jq3Ai"),
    $4a783ebd071e1efd$var$load("bv7z8"),
    $4a783ebd071e1efd$var$load("8A3nE"),
    $4a783ebd071e1efd$var$load("8YSo7"),
    $4a783ebd071e1efd$var$load("g7ggm"),
    $4a783ebd071e1efd$var$load("9S9Mz"),
    $4a783ebd071e1efd$var$load("kiGNy"),
    $4a783ebd071e1efd$var$load("7do1E"),
    $4a783ebd071e1efd$var$load("77dkW"),
    $4a783ebd071e1efd$var$load("arCL2"),
    $4a783ebd071e1efd$var$load("g9CVe"),
    $4a783ebd071e1efd$var$load("7oiUM"),
    $4a783ebd071e1efd$var$load("8t3po"),
    $4a783ebd071e1efd$var$load("855o0"),
    $4a783ebd071e1efd$var$load("8MfZE"),
    $4a783ebd071e1efd$var$load("hv4mn"),
    $4a783ebd071e1efd$var$load("dek7I"),
    $4a783ebd071e1efd$var$load("3SmkN"),
    $4a783ebd071e1efd$var$load("dYtBN"),
    $4a783ebd071e1efd$var$load("kNV5Y"),
    $4a783ebd071e1efd$var$load("6wr18"),
    $4a783ebd071e1efd$var$load("kjZZD"),
    $4a783ebd071e1efd$var$load("bkc7o"),
    $4a783ebd071e1efd$var$load("2wlUS"),
    $4a783ebd071e1efd$var$load("9u7sS"),
    $4a783ebd071e1efd$var$load("1fem1"),
    $4a783ebd071e1efd$var$load("ffEVr"),
    $4a783ebd071e1efd$var$load("hhss7"),
    $4a783ebd071e1efd$var$load("dTsOE"),
    $4a783ebd071e1efd$var$load("9fvYm"),
    $4a783ebd071e1efd$var$load("im1Yv"),
    $4a783ebd071e1efd$var$load("henq4"),
    $4a783ebd071e1efd$var$load("eylda"),
    $4a783ebd071e1efd$var$load("8TDGF"),
    $4a783ebd071e1efd$var$load("8fMw3"),
    $4a783ebd071e1efd$var$load("hogcU"),
    $4a783ebd071e1efd$var$load("dAdaw"),
    $4a783ebd071e1efd$var$load("h3ABO"),
    $4a783ebd071e1efd$var$load("kC80R"),
    $4a783ebd071e1efd$var$load("7EorR"),
    $4a783ebd071e1efd$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.3bea8b6a.js.map
